import PropTypes from "prop-types"
import { useEffect } from "react"
import { Provider } from "react-redux"

import { configureStore, history, store } from "app-store-v2"
import { doLogin } from "app-store-v2/app/actions"
import { experimentInitialState } from "app-store-v2/app/reducers"
import { setCollection, setSSRNotFound } from "areas/collection/store/actions"
import {
  previewImageInitialState,
  wizardInitialState,
} from "areas/product/store/reducers"
import { setLocalStorage } from "helpers/application"

if (typeof window !== "undefined") {
  window.appStore = store
  window.appStoreV2 = store
  window.appHistory = history
}

const AppReduxProvider = (props) => {
  const { children } = props
  const {
    cart,
    collection_data,
    diamond_selector,
    display,
    experiment_result,
    not_found,
    path,
    previewImage,
    sale,
    search_suggestion,
    user_obj,
    user_preferences,
    wishlist,
    wizard,
  } = props
  let newStoreData = {
    cart,
    display: { ...display },
    previewImage: { ...previewImageInitialState, ...previewImage },
    sale,
    searchSuggestion: {
      name: search_suggestion?.name,
      ...search_suggestion?.data,
    },
    wishlist,
    wizard: { ...wizardInitialState, ...wizard },
  }

  if (wizard && wizard.pds) {
    newStoreData.choices = wizard.pds
  }

  if (user_preferences) {
    newStoreData.account = {
      userPreferences: {
        data: user_preferences,
        loaded: true,
      },
    }
  }

  if (diamond_selector) {
    newStoreData.diamondSelector = diamond_selector
  }

  if (experiment_result) {
    newStoreData.experiment = experimentInitialState
    if (experiment_result.free_shipping) {
      newStoreData.experiment = {
        ...newStoreData.experiment,
        freeShipping: experiment_result.free_shipping,
      }
    }
    if (experiment_result.upgraded_shipping) {
      newStoreData.experiment = {
        ...newStoreData.experiment,
        upgradedShipping: experiment_result.upgraded_shipping,
      }
    }

    // Expose product pricing experiences to the Redux store
    const ppt_experiments = {}
    Object.keys(experiment_result)
      .filter((key) => key.startsWith("PPT_"))
      .forEach((experiment_key) => {
        ppt_experiments[experiment_key] = experiment_result[experiment_key]
      })
    if (Object.keys(ppt_experiments).length > 0) {
      newStoreData.experiment = {
        ...newStoreData.experiment,
        ...ppt_experiments,
      }
    }

    // if (experiment_result.mobile_quick_nav) {
    //   newStoreData.experiment = {
    //     ...newStoreData.experiment,
    //     mobileQuickNav: experiment_result.mobile_quick_nav,
    //   }
    // }

    // if (experiment_result.pdp_value_props) {
    //   newStoreData.experiment = {
    //     ...newStoreData.experiment,
    //     pdpValueProps: experiment_result.pdp_value_props,
    //   }
    // }

    if (experiment_result.plp_display_metal) {
      newStoreData.experiment = {
        ...newStoreData.experiment,
        plpDisplayMetal: experiment_result.plp_display_metal,
      }
    }

    // if (experiment_result.unified_stone_picker) {
    //   newStoreData.experiment = {
    //     ...newStoreData.experiment,
    //     unifiedStonePicker: experiment_result.unified_stone_picker,
    //   }
    // }
  }

  const newStore = configureStore(newStoreData)

  if (typeof window !== "undefined") {
    window.appStore = newStore
    window.appStoreV2 = newStore
    window.appHistory = history
  }

  if (collection_data) {
    newStore.dispatch(setCollection(collection_data))
  }

  if (not_found && path) {
    newStore.dispatch(setSSRNotFound(path))
  }

  useEffect(() => {
    if (user_obj && user_obj != "") {
      // HACKY but this will have to do for now
      // its complementing check is located in the fetch-user.jsx HOC
      window.loginStatus = true
      setLocalStorage(user_obj.jewlrorders.user, "user_obj", 365)
      newStore.dispatch(doLogin(user_obj))
    }
  }, [])

  return <Provider store={newStore}>{children}</Provider>
}

AppReduxProvider.propTypes = {
  cache_key: PropTypes.string,
  cart: PropTypes.object,
  children: PropTypes.element,
  collection_data: PropTypes.object,
  collection_path: PropTypes.string,
  diamond_selector: PropTypes.object,
  display: PropTypes.object,
  experiment_result: PropTypes.object,
  landing_data: PropTypes.object,
  not_found: PropTypes.bool,
  path: PropTypes.string,
  previewImage: PropTypes.object,
  sale: PropTypes.object,
  search_suggestion: PropTypes.object,
  user_obj: PropTypes.object,
  user_preferences: PropTypes.object,
  wishlist: PropTypes.object,
  wizard: PropTypes.object,
}

export default AppReduxProvider
